
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2.52c-6.5 0-12 4.35-12 9.5 0 2.1 1.03 3.34 3.23 3.92 1.93.5 4.68.5 8.2.5H12c2.13 0 3.41.43 3.93 1.3a5.77 5.77 0 01.4.98c.42 1.16.98 2.76 3.3 2.76 1.03 0 4.37-.68 4.37-9.46 0-5.15-5.5-9.5-12-9.5zm7.63 17.96c-1.61 0-1.95-.97-2.35-2.09a6.6 6.6 0 00-.49-1.15 2.91 2.91 0 00-.55-.66v-2.63a.5.5 0 00-1 0v2a8.43 8.43 0 00-3.24-.5h-.57a35.97 35.97 0 01-7.94-.48c-1.59-.42-2.33-1.15-2.46-2.48a.5.5 0 00.05.01h2.28a2 2 0 002-2V8.78a.5.5 0 00-1 0v1.72a1 1 0 01-1 1H1.08a.39.39 0 00-.04.01c.24-2.96 2.53-5.57 5.78-6.95v1.68a2 2 0 002 2h2.27a.5.5 0 000-1H8.81a1 1 0 01-1-1V4.18A13.41 13.41 0 0112 3.52c5.96 0 11 3.9 11 8.5a21.96 21.96 0 01-.35 4.19h-.87a1 1 0 01-1-1v-1.06a.5.5 0 00-1 0v1.06a2 2 0 002 2h.63c-.66 2.34-1.77 3.27-2.78 3.27z"}}),_c('path',{attrs:{"d":"M16.7 6.9a.5.5 0 00-.5.5v2.28a1 1 0 01-1 1h-2.27a.5.5 0 000 1h2.27a2 2 0 002-2V7.41a.5.5 0 00-.5-.5z"}})])
          )
        }
      }
    